export default {
  mount: '.icon-arrow-right',
  attrs: {
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  path: `<polygon points="10 17 15 12 10 7"></polygon>
  `
}
